import { Checkbox, Input, InputWrapperProps, TextInput, TextInputProps } from "@mantine/core";
import { useFormHelperContext } from "../form";
import { InputWrapper } from "../inputWrapper";

export interface FieldInputCheckboxProps
  extends InputWrapperProps {
  inputWrapper?: InputWrapperProps;
  label: string;
  checkBoxLabel?: string;
  error?: string;
  name: string
  readOnly?: boolean;
  noWrapperLabel?: boolean;
  disabled?: boolean;
}

const HORIZONTAL_FORM_CLASSES_INPUT = {
  root: "flex-grow"
}

export const FieldInputCheckbox: React.FC<FieldInputCheckboxProps> = ({ label, checkBoxLabel, name, inputWrapper, noWrapperLabel, readOnly, disabled, ...rest }) => {
  const { register, formState, formStore } = useFormHelperContext()
  if (!register) {
    throw new Error("Field.Text must be used within a FormHelper component");
  }

  return (
    <InputWrapper label={noWrapperLabel ? '' : label} {...inputWrapper} withAsterisk={rest.withAsterisk}>
      <Checkbox
        readOnly={readOnly ?? formStore.readOnly}
        // label={checkBoxLabel ? checkBoxLabel : label}
        disabled={disabled ?? false}
        data-testid={'field-input-checkbox-' + name}
        error={typeof formState.errors[name]?.message === 'string' ? formState.errors[name]?.message : undefined}
        classNames={formStore.horizontalForm ? HORIZONTAL_FORM_CLASSES_INPUT : undefined}
        {...register(name)}
      />
    </InputWrapper>

  );
}
